import * as React from 'react';
import injectSheet, { JSSClassesProps } from 'react-jss';
import { observer } from 'mobx-react';

import { StaticView } from './StaticView';
import { ComponentJSSClasses } from './styles';

import S from '../../../stores';
import { AdaptiveType } from '../../../models/adaptive';
import { OpenerBlock } from '../OpenerBlock';
import { ContentLoader as _ContentLoader, ContentLoaderProps } from 'sletat-ui-components/lib/ContentLoader';
import { basicClasses } from 'sletat-ui-components/lib/ContentLoader/themes/basic';

const ContentLoader = injectSheet<ContentLoaderProps>(basicClasses)(
    _ContentLoader
);

export interface HotelOnMapProps { }

interface StyledHotelOnMapProps extends JSSClassesProps<ComponentJSSClasses>, HotelOnMapProps { }

interface HotelOnMapState {
    isClient: boolean;
}

@observer
export class HotelOnMap extends React.Component<StyledHotelOnMapProps, HotelOnMapState> {

    constructor(props: StyledHotelOnMapProps) {
        super(props);
        this.state = {
            isClient: false
        };
    }
    componentDidMount() {
        this.setState({ isClient: true });
    }

    render() {
        const { classes } = this.props;

        if (!this.state.isClient) {
            return (
                <div className={classes.container}>
                    {this.renderPlaceholder()}
                </div>
            );
        }

        switch (S.ui.adaptiveType) {
            // mobile
            case AdaptiveType.LessThan768:
                return (
                    <div className={classes.container}>
                        {this.renderSmall()}
                    </div>
                );

            // tablet + desktop
            case AdaptiveType.MoreThan768:
            case AdaptiveType.MoreThan1024:
                return (
                    <div className={classes.container}>
                        {this.renderLarge()}
                    </div>
                );

            default:
                return null;
        }
    }

    renderSmall(): JSX.Element {
        const { classes } = this.props;

        return (
            <>
                <div
                    className={classes.openButton}
                    onClick={() => S.ui.setIsHotelOnMapOpen(true)}
                >
                    <div className={classes.title}>
                        Показать на карте
                    </div>
                </div>
                <div className={classes.openerBlockWrapper}>
                    <OpenerBlock
                        isOpen={S.ui.isHotelOnMapOpen}
                        title="Отель на карте"
                        fullWidht={true}
                        onClose={() => S.ui.setIsHotelOnMapOpen(false)}
                    >
                        <div className={classes.fullScreenMap}>
                            <StaticView
                                latitude={S.hotelDetails.hotelLatitude}
                                longitude={S.hotelDetails.hotelLongitude}
                                beachType={S.hotelDetails.beachType}
                                beachSandType={S.hotelDetails.beachSandType}
                                distanceToAirport={S.hotelDetails.distanceToAirport}
                                distanceToBeach={S.hotelDetails.distanceToBeach}
                                howLongMinutesToCenterCity={S.hotelDetails.howLongMinutesToCenterCity}
                                isCenterCity={S.hotelDetails.isCenterCity}
                            />
                        </div>
                    </OpenerBlock>
                </div>
            </>
        );
    }

    renderLarge(): JSX.Element {
        const { classes } = this.props;

        return (
            <>
                <div className={classes.title}>
                    Отель {S.hotelDetails.hotelName} на карте
                </div>
                <div className={classes.map}>
                    <StaticView
                        latitude={S.hotelDetails.hotelLatitude}
                        longitude={S.hotelDetails.hotelLongitude}
                        beachType={S.hotelDetails.beachType}
                        beachSandType={S.hotelDetails.beachSandType}
                        distanceToAirport={S.hotelDetails.distanceToAirport}
                        distanceToBeach={S.hotelDetails.distanceToBeach}
                        howLongMinutesToCenterCity={S.hotelDetails.howLongMinutesToCenterCity}
                        isCenterCity={S.hotelDetails.isCenterCity}
                    />
                </div>
            </>
        );
    }

    renderPlaceholder(): JSX.Element {
        const { classes } = this.props;

        return (
            <>
                <div className={classes.ssrWrap}>
                    <div className={classes.title}>
                        Отель {S.hotelDetails.hotelName} на карте
                    </div>
                    <div className={classes.ssrMap}>
                        <ContentLoader />
                    </div>
                </div>
            </>
        );
    }
}
